import { FaMapMarkerAlt, FaSlash, FaDrawPolygon, FaRegCircle, FaRegSquare } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
const RiskMapItemView = ({ item, handleItemHighlight }) => {
    const navigate = useNavigate();
    const handleItemView = (itemId, routePath) => {
        navigate('/' + routePath, { state: { itemId: itemId, navigateFrom: 'Risk' } });
    }

    return (
        <tr>
            <td>

                <a onMouseOver={(itemId) => handleItemHighlight(item.itemId)} onMouseOut={(itemId) => handleItemHighlight(0)}>
                    {item.mapMarkerType == 'marker' ? <FaMapMarkerAlt color={item.colour}></FaMapMarkerAlt> :
                        item.mapMarkerType == 'polyline' ? <FaSlash color={item.colour}></FaSlash> :
                            item.mapMarkerType == 'polygon' ? <FaDrawPolygon color={item.colour}></FaDrawPolygon> :
                                item.mapMarkerType == 'circle' ? <FaRegCircle color={item.colour}></FaRegCircle> :
                                    item.mapMarkerType == 'rectangle' && <FaRegSquare color={item.colour}></FaRegSquare>}
                </a>

            </td>
            <td>{item.name} </td>
            <td>{item.sectionName} </td>
            <td>{item.itemTypeName} </td>
            <td>{item.itemActions.openActionCount == 0 ? "" : item.itemActions.openActionCount} </td>
            <td>
                <button type="button" id={"view" + item.itemId}
                    onClick={(itemId, routePath) => handleItemView(item.itemId, item.routePath)}
                    className="btn btn-primary btn-sm">
                    View
                </button>
            </td>
        </tr>
    )
}
export default RiskMapItemView;